import React, { useState } from "react";
import { useSelector } from "react-redux";
import useForm from "../../hooks/useForm";
import { AddNewStudentService } from "../../services/competitions";
import { textIdentifier } from "../../textIdentifier";

const AddNewStudent = ({ setShowAddStudentModal }) => {
  const { selectedCompetition, selectedSchool, selectedClass, lang } = useSelector(
    (state) => state.main
  );
  const [error, setError] = useState("");

  const handleSubmit = async (values) => {
    try {
      const data = {
        first_name: values.firstName,
        last_name: values.lastName,
        email: values.email,
        password: values.password,
      };
      if (Object.keys(addNewStudentForm.errors).length < 1) {
        await AddNewStudentService(selectedClass.code, data);
        setShowAddStudentModal(false);
      }
    } catch (error) {
      if (error?.detail === "Error decoding signature.") {
        setError("Student cannot be added!");
      } else {
        setError(error.data.message || "Student cannot be added!");
      }
    } finally {
      addNewStudentForm.setSubmitting();
    }
  };

  const addNewStudentForm = useForm({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.firstName.trim()) {
        errors.firstName = textIdentifier["please-enter-first-name"][lang];
      }
      if (!values.lastName.trim()) {
        errors.lastName = textIdentifier["please-enter-last-name"][lang];
      }
      if (!values.email.trim()) {
        errors.email =  textIdentifier["please-enter-email"][lang];
      }
      const emailValidationRegex =
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (!emailValidationRegex.test(values.email)) {
        errors.email =  textIdentifier["invalid-email-please-enter-a-valid-email"][lang];
      }
      if (!values.password) {
        errors.password = textIdentifier["please-enter-password"][lang];
      }
      if (!values.confirmPassword) {
        errors.confirmPassword = textIdentifier["please-enter-confirm-password"][lang];
      }
      if (values.password !== values.confirmPassword) {
        errors.confirmPassword = textIdentifier["please-enter-confirm-password"][lang];
      }
      if (Boolean(error)) {
        setError("");
      }
      return errors;
    },
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  return (
    <div
      id="AddNewStudent"
      className="tabcontent active"
      style={{ display: "block" }}
    >
      <form onSubmit={addNewStudentForm.handleSubmit}>
        <div className="form-group">
          <label for="firstName" className="form-label">
            {textIdentifier["first-name"][lang]}
          </label>
          <input
            placeholder={textIdentifier["enter-student-first-name"][lang]}
            className="form-control"
            id="firstName"
            value={addNewStudentForm.values.firstName}
            onChange={addNewStudentForm.handleChange}
          />
        </div>

        <div className="form-group">
          <label for="lastName" className="form-label">
            {textIdentifier["last-name"][lang]}
          </label>
          <input
            placeholder={textIdentifier["enter-student-last-name"][lang]}
            className="form-control"
            id="lastName"
            value={addNewStudentForm.values.lastName}
            onChange={addNewStudentForm.handleChange}
          />
        </div>

        <div className="form-group">
          <label for="email" className="form-label">
            {textIdentifier["enter-ID"][lang]}
          </label>
          <input
            placeholder={textIdentifier["enter-student-enter-ID"][lang]}
            className="form-control"
            id="email"
            value={addNewStudentForm.values.email}
            onChange={addNewStudentForm.handleChange}
          />
        </div>

        <div className="form-group">
          <label for="password" className="form-label">
            {textIdentifier["password"][lang]}
          </label>
          <input
            type="password"
            placeholder={textIdentifier["min-6-characters"][lang]}
            className="form-control"
            id="password"
            value={addNewStudentForm.values.password}
            onChange={addNewStudentForm.handleChange}
          />
        </div>

        <div className="form-group">
          <label for="confirmPassword" className="form-label">
            {textIdentifier["confirm-password"][lang]}
          </label>
          <input
            type="password"
            placeholder={textIdentifier["min-6-characters"][lang]}
            className="form-control"
            id="confirmPassword"
            value={addNewStudentForm.values.confirmPassword}
            onChange={addNewStudentForm.handleChange}
          />
        </div>

        {Object.values(addNewStudentForm.errors).length > 0 && (
          <div className="form-group">
            <div id="helperText" className="form-text">
              {Object.values(addNewStudentForm.errors).length &&
                Object.values(addNewStudentForm.errors)[0]}
            </div>
          </div>
        )}

        {Boolean(error) && (
          <div className="form-group">
            <div id="helperText" className="form-text">
              {error}
            </div>
          </div>
        )}

        <div className="btn-container">
          <button
            type="button"
            className="btn-outlined w-50"
            onClick={() => setShowAddStudentModal(false)}
          >
           {textIdentifier["cancel"][lang]}
          </button>
          <button
            type="submit"
            className="btn-contained w-50"
            disabled={addNewStudentForm.isSubmitting}
          >
           {textIdentifier["add"][lang]}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddNewStudent;
